import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleReview from "@/pages/article-review/page";
import ArticleShipping from "@/pages/article-shipping/page";
import ArticleCoupon from "@/pages/article-coupon/page";
import ArticleLegit from "@/pages/article-legit/page";
import ArticleWarehouse from "@/pages/article-warehouse/page";
import ArticleHowToUse from "@/pages/article-how-to-use/page";
import ArticleBestFinds from "@/pages/article-best-finds/page";
import ArticleVsAgents from "@/pages/article-vs-agents/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/sugargoo-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/sugargoo-review-2026",
    element: <ArticleReview />,
  },
  {
    path: "/article/sugargoo-shipping-cost-guide",
    element: <ArticleShipping />,
  },
  {
    path: "/article/sugargoo-coupon-discount-guide",
    element: <ArticleCoupon />,
  },
  {
    path: "/article/is-sugargoo-legit",
    element: <ArticleLegit />,
  },
  {
    path: "/article/sugargoo-warehouse-guide",
    element: <ArticleWarehouse />,
  },
  {
    path: "/article/how-to-use-sugargoo-spreadsheet",
    element: <ArticleHowToUse />,
  },
  {
    path: "/article/best-sugargoo-finds-2026",
    element: <ArticleBestFinds />,
  },
  {
    path: "/article/sugargoo-vs-other-agents",
    element: <ArticleVsAgents />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;